import styles from './backgroundBanner.module.scss';
import dlsContentStyles from 'src/styles/dlsContentStyles.module.scss';
import worldserviceTilePng from 'src/assets/png/worldservice-tile-deepblue.png';
import React, { PropsWithChildren } from 'react';

const BackgroundBanner = ({ children }: PropsWithChildren<{}>): JSX.Element => {
    return (
        <div className={styles.backgroundWrapper}>
            <div
                className={`${styles.backgroundBanner} ${dlsContentStyles.dlsBackgroundBanner}`}
                style={{ backgroundImage: `url(${worldserviceTilePng})` }}
            />
            {children}
        </div>
    );
};

export default BackgroundBanner;
